export default "50b348bfdce3e6f3.svg"